/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Dialog,
  DialogBody,
  DialogIcon,
  DialogText,
  ContentTextarea,
  DialogCancel,
  DialogConfirm,
} from './styles';

export default function ModalConfirmation({ show, showTitle = true, onConfirm, onCancel, title = '', text, textButtonConfirm, textButtonCancel }) {

  const myRef = useRef();

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <Dialog canShow={show} >
      <DialogBody ref={myRef}>
        {showTitle &&
          <DialogIcon pink={'exclamation'}>
            <FontAwesomeIcon icon={['fas', 'exclamation']}></FontAwesomeIcon>
            <DialogText>{title || 'Important notice'}</DialogText>
          </DialogIcon>
        }
        <ContentTextarea>
          <p>
            {text || 'Are you sure sure you want to delete this file?'}
          </p>
          <br />
          <DialogCancel
            onClick={() => {
              onCancel && onCancel();
            }}
          >
            {textButtonCancel || 'NO'}
          </DialogCancel>
          <DialogConfirm onClick={() => handleConfirm()}>
            {textButtonConfirm || 'YES'}
          </DialogConfirm>
        </ContentTextarea>
      </DialogBody>
    </Dialog>

  );
}